export class ErrorChartLabel {
    displayValue: string;
    value: number;

    constructor(displayValue: string, value: number) {
        this.displayValue = displayValue;
        this.value = value;
    }
}
